/* ===== Sidekicks Theme JS ===== */

/* --- Age gate: real 30-day cookie --- */
function skConfirmAge(){
  var d = new Date(); d.setTime(d.getTime() + 30*24*60*60*1000);
  document.cookie = "sk_age_verified=1;expires=" + d.toUTCString() + ";path=/";
  var el = document.getElementById('agegate');
  if (el) el.style.display = 'none';
}

document.addEventListener('DOMContentLoaded', function(){
  var declineBtn = document.getElementById('agegate-decline-btn');
  if (declineBtn) {
    declineBtn.addEventListener('click', function(){
      document.getElementById('agegate-decline').style.display = 'block';
      document.querySelector('.agegate-btns').style.display = 'none';
    });
  }
  var confirmBtn = document.getElementById('agegate-confirm-btn');
  if (confirmBtn) {
    confirmBtn.addEventListener('click', skConfirmAge);
  }
});

/* --- Shipping / state eligibility checker ---
   PLACEHOLDER ONLY: RESTRICTED_PLACEHOLDER must be replaced with a current,
   attorney-verified list before launch. Ideally this list should be generated
   from your actual Shopify shipping zones rather than hardcoded here, so it
   can never drift out of sync with what customers can actually check out with. */
var SK_US_STATES = ["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming"];
var SK_RESTRICTED_PLACEHOLDER = ["Idaho","Kansas"];

document.addEventListener('DOMContentLoaded', function(){
  var stateSelect = document.getElementById('stateSelect');
  if (stateSelect && stateSelect.options.length <= 1) {
    SK_US_STATES.forEach(function(s){
      var opt = document.createElement('option');
      opt.value = s; opt.textContent = s;
      stateSelect.appendChild(opt);
    });
  }
  var checkBtn = document.getElementById('shipCheckBtn');
  if (checkBtn) {
    checkBtn.addEventListener('click', function(){
      var val = stateSelect.value;
      var result = document.getElementById('shipResult');
      if (!val || !result) return;
      if (SK_RESTRICTED_PLACEHOLDER.indexOf(val) !== -1) {
        result.className = 'ship-result show no';
        result.textContent = "We're not currently able to ship to " + val + ". We're working on it — join our list to hear when that changes.";
      } else {
        result.className = 'ship-result show yes';
        result.textContent = "Good news — we ship to " + val + ". Delivered discreetly in 3–5 business days.";
      }
    });
  }
});

/* --- FAQ live search (used on FAQ page) --- */
document.addEventListener('DOMContentLoaded', function(){
  var searchInput = document.getElementById('faqSearch');
  if (!searchInput) return;
  var allCats = document.querySelectorAll('.faq-cat');
  searchInput.addEventListener('input', function(){
    var q = searchInput.value.trim().toLowerCase();
    allCats.forEach(function(cat){
      var anyVisible = false;
      cat.querySelectorAll('.faq-item').forEach(function(item){
        var text = item.textContent.toLowerCase();
        var match = q === '' || text.indexOf(q) !== -1;
        item.style.display = match ? '' : 'none';
        if (match) { anyVisible = true; if (q !== '') item.setAttribute('open', ''); }
      });
      cat.style.display = (q === '' || anyVisible) ? '' : 'none';
    });
  });
});

/* --- PDP gallery thumbnail swap --- */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.gallery-thumbs [data-full]').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      document.querySelectorAll('.gallery-thumbs div').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = document.getElementById('galleryMainImg');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full');
    });
  });
});

/* --- PDP purchase toggle (Subscribe & Save vs One-Time) ---
   Reads data-selling-plan / price data straight from the DOM so this works
   with whatever variant/selling-plan combination Shopify renders. */
document.addEventListener('DOMContentLoaded', function(){
  var optSub = document.getElementById('optSub');
  var optOne = document.getElementById('optOne');
  if (!optSub || !optOne) return;
  var priceMain = document.getElementById('priceMain');
  var sellingPlanInput = document.getElementById('sellingPlanInput');

  optSub.addEventListener('click', function(){
    optSub.classList.add('selected'); optOne.classList.remove('selected');
    if (priceMain) priceMain.textContent = optSub.getAttribute('data-price');
    if (sellingPlanInput) sellingPlanInput.value = optSub.getAttribute('data-selling-plan') || '';
  });
  optOne.addEventListener('click', function(){
    optOne.classList.add('selected'); optSub.classList.remove('selected');
    if (priceMain) priceMain.textContent = optOne.getAttribute('data-price');
    if (sellingPlanInput) sellingPlanInput.value = '';
  });
});

/* --- Shop page filter chips (client-side show/hide by data-flavor) --- */
document.addEventListener('DOMContentLoaded', function(){
  var chips = document.querySelectorAll('.filter-chip[data-filter]');
  if (!chips.length) return;
  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      chips.forEach(function(c){ c.classList.remove('active'); });
      chip.classList.add('active');
      var filter = chip.getAttribute('data-filter');
      document.querySelectorAll('.product-card[data-tags]').forEach(function(card){
        var tags = card.getAttribute('data-tags') || '';
        card.style.display = (filter === 'all' || tags.indexOf(filter) !== -1) ? '' : 'none';
      });
    });
  });
});
